"use client";

import { useSyncExternalStore } from "react";
import type { Status } from "./data";

/* your account's live presence — tiny external store so the profile bar,
   hero and status picker stay in sync without prop drilling. clearAt is
   the "clear after" label (null = until changed). */
let self: { status: Status; clearAt: string | null } = {
  status: "online",
  clearAt: null,
};
const subs = new Set<() => void>();

export function setSelfStatus(status: Status, clearAt: string | null = null) {
  self = { status, clearAt };
  subs.forEach((f) => f());
}

export function useSelf() {
  return useSyncExternalStore(
    (f) => {
      subs.add(f);
      return () => {
        subs.delete(f);
      };
    },
    () => self,
    () => self,
  );
}
